import { flow, getParent, getRoot, Instance, types } from 'mobx-state-tree';
import { selectFolder } from 'service/utils';
import { ProductState } from 'types/enum';
import { IRootStore } from '../root';
import { IProductLibrary } from './product-library';

const { coreappIpc } = window;
// getInstalledApps

export interface IInstallInfo extends Instance<typeof InstallInfo> {}
export const InstallInfo = types
    .model('InstallInfo', {
        gameSize: types.optional(types.number, 0),
        // installPath: types.optional(types.string, '', [null, undefined]),
        installRootPath: types.optional(types.string, '', [null, undefined]),
        localManifest: types.optional(types.string, '', [null, undefined]),
        autoUpdate: types.optional(types.boolean, true),
        installTime: types.optional(types.number, 0),
        currentState: types.optional(types.number, ProductState.NOT_INSTALLED),
        currentBranch: types.optional(types.string, 'public'),
        // customTargetBuildId: types.optional(types.string, '', [null, undefined]),
        customLaunchConfigEnable: types.optional(types.boolean, false),
        customLaunchConfigExe: types.optional(types.string, '', [null, undefined]),
        customLaunchConfigArgs: types.array(types.string),
        diskSpace: types.optional(types.number, 0),
    })
    .views((self) => ({
        get root(): IRootStore {
            return getRoot<IRootStore>(self);
        },
        get parent(): IProductLibrary {
            return getParent<IProductLibrary>(self);
        },
    }))
    .views((self) => ({
        get productId(): string {
            return self.parent.productId;
        },
        get directoryName(): string {
            return self.parent.detail?.directoryName || self.parent.productName;
        },
    }))
    .actions((self) => ({
        setBranchName: (branch: string) => {
            self.currentBranch = branch;
        },
        setInstallRootPath: flow(function* (path = '') {
            try {
                if (!path) {
                    path = (yield selectFolder(self.installRootPath)) as string;
                }
                self.installRootPath = path;
            } catch (e) {
                console.error(e);
                return;
            }
            yield coreappIpc.send('setInstallRootPath', self.productId, self.directoryName, path);
        }),
        updateCurrentState(val: number) {
            self.currentState = val;
        },
        updateSettings: ({
            autoUpdate = self.autoUpdate,
            customLaunchConfigEnable = self.customLaunchConfigEnable,
            customLaunchConfigExe = self.customLaunchConfigExe,
            customLaunchConfigArgs = self.customLaunchConfigArgs,
        }: any) => {
            self.autoUpdate = autoUpdate;
            self.customLaunchConfigEnable = customLaunchConfigEnable;
            self.customLaunchConfigExe = customLaunchConfigExe;
            self.customLaunchConfigArgs = customLaunchConfigArgs;
            window.nxlApi.appsInstaller.updateSettings({
                productID: self.parent.productId,
                options: {
                    autoUpdate: self.autoUpdate,
                    customLaunchConfigEnable: self.customLaunchConfigEnable,
                    customLaunchConfigExe: self.customLaunchConfigExe,
                    customLaunchConfigArgs: self.customLaunchConfigArgs.toJSON(),
                },
            });
        },
    }));
